'use client';

import styles from './VideoSlideMbaLp.module.scss'
import style from './ReviewSectionMbaLp.module.scss'
import PlayIcon from '@/SvgIcons/PlayIcon';

export default function VideoSlideMba({ data, index, handlePlayClick }) {

  const thumb = data?.ThumbNail?.data?.attributes?.url

  return (
    <div className={styles.videoContainer}>
      <div className={style.reviewContent}>
        <div className={style.reviewerImg}>
          <img
            src={data?.Image?.data?.attributes?.url || "/default-avatar.png"}
            alt={data?.name || `reviewer-${index + 1}`}
            width={100}
            height={100}
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className={style.reviewerDetails}>
          <h3 className={style.reviewerName}>
            {data?.label || ""}
          </h3>
          <p className={style.reviewerDegree}>
            {data?.sublabel || ""}
          </p>
          <p className={style.stars}>
          {Array.from({ length: 5 }).map((_, i) => (
           <span key={i}>{i < data?.stars ? "★" : "☆"}</span>
          ))}
           </p>
        </div>
      </div>

      <div className={styles.preview} style={{ width: "100%", height: "100%", position: "relative" }}>
        <img
          src={thumb}
          alt="YouTube Thumbnail"
          style={{ objectFit: "cover", borderRadius: 12, height: "100%", width: "100%" }}
        />
        <button className={styles.playButton} onClick={() => handlePlayClick(data?.link)} id="video-play-btn" aria-label="Play Video">
          <PlayIcon />
        </button>
      </div>

      <button
        className={styles.readMoreBtn}
        onClick={() => handlePlayClick(data?.link)}
        id={"read-full-testimonial-" + index}
      >
        Watch Now
      </button>
    </div>
  );
}
